<template>
    <div class="outer-photo-container" ref="outerPhotoContainer">
        <div class="icon-container">
            <template v-if="image">
                <button class="btn btn-primary" data-toggle="modal" :data-target="'#modal-delete-' + index" >
                    <i class="fa fa-trash fa-2x" aria-hidden="true"></i>
                </button>
                <button class="btn btn-primary" @click="handleDownloadMarketingPhoto">
                    <i class="fa fa-cloud-download fa-2x" aria-hidden="true"></i>
                </button>
            </template>
            <template v-else>
                <button class="btn btn-primary" @click="handleGetFileInput">
                    <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
                </button>
            </template>
        </div>
        <input ref="fileInput" type="file" :id="'imageUrl_' + index" name="marketingPhoto" @change="handleAddMarketingPhoto">
        <!--    The talent marketing photo is set as the background to the div below    -->
        <div class="photo-container" :style="{ backgroundImage: 'url('+photo.file_url+')' }"></div>
        <talent-delete-photo-modal :idKey="index" @deletePhoto="handleDeleteMarketingPhoto"></talent-delete-photo-modal>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { notify } from 'utils'
import TalentDeletePhotoModal from './TalentDeletePhotoModal'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [OpportunityTracker],
  name: 'TalentMarketingPhoto',

  data () {
    return {
      default_photo: '/img/profile-default.jpg'
    }
  },

  props: [
    'image',
    'index'
  ],

  components: {
    TalentDeletePhotoModal
  },

  computed: {
    ...mapState('user', ['user']),

    photo () {
      if (this.image && this.image.file_url) {
        return this.image
      }
      return { file_url: this.default_photo }
    },

    downloadPhotoUrl () {
      return this.photo.file_url
    }
  },

  methods: {
    ...mapActions('talent/profile', ['deleteTalentMarketingPhoto', 'addMarketingPhoto']),

    /*
     * Opens the file input window
     *
     * @return void
     */
    handleGetFileInput () {
      this.$refs.fileInput.value = null
      this.$refs.fileInput.click()
    },

    /**
     * Handle deleting talent marketing photo
     *
     * @return void
     */
    handleDeleteMarketingPhoto () {
      let payload = {
        'id': this.user.id,
        'photoUrl': this.photo.photo_hash
      }

      this.deleteTalentMarketingPhoto(payload)
        .then(response => {
          this.$emit('delete')
          notify.success('Successfully deleted photo.')
          this.trackEvent(this.analytics.V2.AccountSectionEditEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.IMAGE })
        })
        .catch(() => {
          notify.error('Sorry something went wrong deleting your photo, please try again.')
        })
    },

    /**
     * Handle adding talent marketing photo
     *
     * @return void
     */
    handleAddMarketingPhoto ({ target: { files } }) {
      this.errors.clear()

      // Check file is present and of image type
      if (files.length !== 0) {
        if (!/^image\/\w+/.test(files.item(0).type)) {
          this.$nextTick(() => {
            notify.error('The file you have selected is an invalid image type')
          })
          return
        }

        let payload = {
          id: this.user.id,
          photoUrl: this.photo !== undefined ? this.photo.hash : null,
          file: files.item(0)
        }

        this.addMarketingPhoto(payload)
          .then(response => {
            this.$emit('upload', response.data)
            notify.success('Successfully Added photo.')
            this.trackEvent(this.analytics.V2.AccountMediaImageUploadEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.IMAGE })
          })
          .catch(() => {
            notify.error('Sorry something went wrong adding your photo, please try again.')
          })
      }
    },

    handleDownloadMarketingPhoto () {
      window.location.assign(this.downloadPhotoUrl)
    }
  }
}
</script>
